import React from 'react';
import { X } from 'lucide-react';
import { PalletSummaryDto, PalletItemDto } from '../../../../../types/picking';

interface PalletInfoModalProps {
  isOpen: boolean;
  pallet: PalletSummaryDto | null;
  onClose: () => void;
}

export const PalletInfoModal: React.FC<PalletInfoModalProps> = ({
  isOpen,
  pallet,
  onClose
}) => {
  if (!isOpen || !pallet) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-white w-full h-full sm:h-auto sm:rounded-lg sm:max-w-md overflow-y-auto">
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <h3 className="text-lg font-semibold">Pall-informasjon</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 min-h-[44px] min-w-[44px] flex items-center justify-center"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-4 sm:p-6 space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-600">SSCC:</span>
            <span className="font-medium">{pallet.sscc}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Nivå:</span>
            <span className="font-medium">{pallet.ssccLevel}</span>
          </div>
          {pallet.ssccParent && (
            <div className="flex justify-between">
              <span className="text-gray-600">Forelder-SSCC:</span>
              <span className="font-medium">{pallet.ssccParent}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-gray-600">Antall varer:</span>
            <span className="font-medium">{pallet.totalItems}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total mengde:</span>
            <span className="font-medium">{pallet.totalQuantity} stk</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total vekt:</span>
            <span className="font-medium">{pallet.totalWeight} kg</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Status:</span>
            <span className={`font-medium ${pallet.isActive ? 'text-green-600' : 'text-gray-600'}`}>
              {pallet.isActive ? 'Aktiv' : 'Inaktiv'}
            </span>
          </div>
          {pallet.created && (
            <div className="flex justify-between">
              <span className="text-gray-600">Opprettet:</span>
              <span className="font-medium">
                {new Date(pallet.created).toLocaleString('no-NO')}
              </span>
            </div>
          )}
          {pallet.createdBy && (
            <div className="flex justify-between">
              <span className="text-gray-600">Opprettet av:</span>
              <span className="font-medium">{pallet.createdBy}</span>
            </div>
          )}
        </div>

        {pallet.items.length > 0 && (
          <div className="mt-4 pt-4 border-t border-gray-200 mb-4 px-4 sm:px-6">
            <h4 className="font-medium mb-2">Varer på pall:</h4>
            <div className="space-y-2 max-h-60 sm:max-h-48 overflow-y-auto">
              {pallet.items.map((item: PalletItemDto, index: number) => (
                <div key={`${item.orderNo}-${item.lineNo}-${item.itemBatchNo}`} className="text-sm bg-gray-50 p-2 rounded">
                  <div className="font-medium text-gray-700">
                    Ordre {item.orderNo}, Linje {item.lineNo}: {item.quantity} stk
                  </div>
                  {item.gtin && (
                    <div className="text-gray-600">GTIN: {item.gtin}</div>
                  )}
                  {item.itemBatchNo && (
                    <div className="text-gray-600">Batch: {item.itemBatchNo}</div>
                  )}
                  {item.itemBatchExpDate && (
                    <div className="text-gray-600">
                      Utløpsdato: {new Date(item.itemBatchExpDate).toLocaleDateString('no-NO')}
                    </div>
                  )}
                  {item.locationName && (
                    <div className="text-gray-600">Lokasjon: {item.locationName}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};